exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".creation_menu__wrapper--3gGN_ {\n\twidth: 100%;\n\theight: 100%;\n}\n", ""]);

// exports
exports.locals = {
	"wrapper": "creation_menu__wrapper--3gGN_"
};